// @flow

import React, {
  createContext,
  type ComponentType,
} from 'react';

export type ComponentMap = { [string]: ComponentType<*> };
type InjectedProps = { componentMapping: ComponentMap | void };

export const ComponentMapping = createContext<Object>({});

export function getComponentMapping<Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<$Diff<Props, InjectedProps>> {
  return props => (
    <ComponentMapping.Consumer>
      {(componentMapping: ComponentMap) => (
        <WrappedComponent
          {...props}
          componentMapping={componentMapping}
        />
      )}
    </ComponentMapping.Consumer>
  );
}

export const setComponentMapping = (value: ComponentMap) => (
  function componentMappingProvider<Props: {}>(
    Component: ComponentType<Props>,
  ): ComponentType<Props> {
    return (
      props: Props,
    ) => (
      <ComponentMapping.Provider value={value}>
        <Component {...props} />
      </ComponentMapping.Provider>
    );
  }
);

export default null;
